__turbopack_context__.v({
  "className": "noto_sans_sinhala_22b32a99-module__uu2gZW__className",
});
